import ChatLoader from './ChatLoader';
import BannerOne from '../../components/ads/300x250';
import BannerTwo from '../../components/ads/300x250two';
import BannerThree from '../../components/ads/300x250three';
import './chatsPage.scss';

function ChatsPage() {
  return (
    <div className="profilePage">
      <div className="chatContainer">
        <div className="wrapper">

          {/* 🟢 First banner */}
          <div className="adsContainer">
            <BannerTwo />
          </div>

          {/* 🟡 ChatLoader */}
          <ChatLoader />

          {/* 🔵 Second banner */}
          <div className="adsContainerR">
            <BannerOne />
            <BannerThree />
          </div>

        </div>
      </div>
    </div>
  );
}

export default ChatsPage;
